import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import RegisterForm from '../../components/Forms/RegisterForm/RegisterForm.jsx';
// import SocialAuthentication from '../../components/SocialAuthentication/SocialAuthentication.jsx';
import SubmitButton from '../../components/Forms/RegisterForm/SubmitButton.jsx';
import StepLayout from '../../components/RegistrationSteps/StepLayout.jsx';

import conf from '../../../shared/conf.js';
import redirectPostLogin from '../../services/redirectPostLogin.js';
import {generate} from '../../routes.js';

class Register extends PureComponent {
  static propTypes = {
    accountType: PropTypes.number.isRequired,
    metaDescription: PropTypes.string.isRequired,
    metaTitle: PropTypes.string.isRequired,
    steps: PropTypes.array,
  };

  static defaultProps = {
    steps: []
  };

  redirectPostLogin = (result) => {
    redirectPostLogin(result.data);
  };

  render() {
    const {accountType, metaDescription, metaTitle, steps, universes} = this.props;

    const helmet = <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription}/>
      <meta property="og:description" content={metaDescription}/>
      <meta property="og:title" content={metaTitle}/>
    </Helmet>;

    return <StepLayout
      helmet={helmet}
      steps={steps}
      title={`S'inscrire - ${accountType === conf.accountTypes.freelance ? 'Consultant' : 'Entreprise'}`}
    >
      <RegisterForm accountType={accountType} onSubmitSuccess={this.redirectPostLogin} universes={universes}/>
      <div className="text-center">
        <SubmitButton className="btn btn-primary">S'inscrire</SubmitButton>
      </div>
      {/*<div className="separator-x bg-gray-200 my-4"/>*/}
      {/*<SocialAuthentication actionVerb="S'inscrire" redirect={this.redirectPostLogin}/>*/}
      <p className="text-center mt-4 mb-0">
        Vous avez déjà un compte ? <Link className="d-inline-block" to={generate({name: 'login'})}>Connectez-vous</Link>
      </p>
    </StepLayout>;
  }
}

export default connect(
  (state) => ({
    universes: state.universe.universes
  })
)(withRouter(Register));
